<app-title-bar titleText="i18n.core.navigation.asset-storage-settings"></app-title-bar>
<div class="row grow w-100">
  <div class="col-4">
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-between">
        <span>
          {{'i18n.domain.assets.asset-storage-settings.overview.header' | translate }}
        </span>
        <div>
          <span class="e-icons icon-add e-icon-big ms-2"
            title="{{ 'i18n.domain.assets.asset-storage-settings.overview.add-button-tooltip' | translate }}"
            (click)="addPermissionGroup()">
          </span>
        </div>
      </div>
    </div>
    <div class="form-row row">
      <ejs-grid #grid class="grid-with-toolbar" width="100%" rowHeight="38" [dataSource]="data" [allowSorting]="true"
        [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]="true" [filterSettings]="filterSettings"
        (rowSelected)="onRowSelected($event)" [editSettings]="customEditSettings" (actionComplete)="actionComplete($event)">
        <e-columns>
          <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
          <e-column field="name"
            headerText="{{'i18n.domain.assets.asset-storage-settings.overview.column-headers.name' | translate}}"
            clipMode="EllipsisWithTooltip">
          </e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
  @if (permissionGroup) {
    <div class="col-8 h-100">
      <div class="e-card">
        <div class="e-card-content">
          <app-permission-group-user-assignment [permissionGroup]="permissionGroup"
          (dataChange)="dataChanged()"></app-permission-group-user-assignment>
        </div>
        <div class="e-card-actions">
          <div class="d-flex justify-content-between">
            <button type="button" (click)="deletePermissionGroup()" class="btn btn-outline-danger me-2 rounded">
              <span class="e-icons icon-erase danger me-2"></span>
              {{ 'i18n.domain.assets.asset-storage-settings.overview.delete-button-text' | translate }}
            </button>
            <button type="submit" (click)="onSave()"
              class="btn btn-outline-primary btn-fixedw rounded">
              {{ 'i18n.domain.assets.asset-storage-settings.overview.save-button-text' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<ejs-dialog #groupDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="cancelClicked()">
  <ng-template #header>
    {{'i18n.domain.assets.asset-storage-settings.form.group-dialog-title' | translate}}
  </ng-template>

  <ng-template #content>
    <app-permission-group-form [permissionGroupForm]="permissionGroupForm"></app-permission-group-form>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="okClicked()">{{'i18n.shared.ok' | translate}}</button>
      <button class="e-control e-btn e-lib e-flat" (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
